export default {
  apiUrl: process.env.NODE_ENV !== 'production' ? 'https://www.estelum-polifonia.com//spip.php?page=api' : '/spip.php?page=api',
  evtsUrl: process.env.NODE_ENV !== 'production' ? 'https://www.estelum-polifonia.com//spip.php?page=evts' : '/spip.php?page=evts'
}
